// src/admin/AdminDashboard.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Import All Tabs
import HeroTab from './tabs/HeroTab';
import CandidatesTab from './tabs/CandidatesTab';
import PartnersTab from './tabs/PartnersTab';
import PartnersTab2 from './tabs/PartnersTab2';
import TestimonialsTab from './tabs/TestimonialsTab'; // Manual Testimonials
import SchoolStoriesTab from './tabs/SchoolStoriesTab'; // NEW: User Submitted Stories
import FAQTab from './tabs/FAQTab';
import AboutTab from './tabs/AboutTab';
import BlogTab from './tabs/BlogTab';
import SchoolInquiriesTab from './tabs/SchoolInquiriesTab';
import FormConfigTab from './tabs/FormConfigTab';

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('inquiries'); // Default tab set to Inquiries

    // Check Auth
    useEffect(() => {
        const isAdmin = localStorage.getItem('isAdmin');
        if (!isAdmin) {
            navigate('/admin');
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('adminUser');
        navigate('/admin');
    };

    const renderContent = () => {
        switch(activeTab) {
            case 'inquiries': return <SchoolInquiriesTab />;
            case 'candidates': return <CandidatesTab />;
            case 'hero': return <HeroTab />;
            case 'partners': return <PartnersTab />;
            case 'partners2': return <PartnersTab2 />;
            case 'testimonials': return <TestimonialsTab />;
            case 'stories': return <SchoolStoriesTab />; // NEW TAB RENDER
            case 'blog': return <BlogTab />;
            case 'faq': return <FAQTab />;
            case 'about': return <AboutTab />;
            case 'formConfig': return <FormConfigTab />;
            default: return <SchoolInquiriesTab />;
        }
    };

    return (
        <div className="min-h-screen bg-slate-100 flex flex-col md:flex-row">
            
            {/* SIDEBAR */}
            <aside className="w-full md:w-64 bg-slate-900 text-white flex-shrink-0 h-screen overflow-y-auto custom-scrollbar">
                <div className="p-6 border-b border-slate-800 flex justify-between items-center sticky top-0 bg-slate-900 z-10">
                    <span className="font-black text-xl uppercase tracking-tighter">Admin<span className="text-orange-500">Panel</span></span>
                </div>
                
                <nav className="p-4 space-y-1">
                    
                    {/* --- GROUP 1: APPLICATIONS & DATA --- */}
                    <p className="px-4 py-2 text-[10px] font-bold text-slate-500 uppercase tracking-widest mt-2">Applications</p>
                    
                    <button onClick={() => setActiveTab('inquiries')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'inquiries' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        School Inquiries
                    </button>
                    <button onClick={() => setActiveTab('candidates')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'candidates' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        Candidate Apps
                    </button>

                    {/* --- GROUP 2: WEBSITE CONTENT --- */}
                    <p className="px-4 py-2 text-[10px] font-bold text-slate-500 uppercase tracking-widest mt-4">Content Manager</p>
                    
                    <button onClick={() => setActiveTab('hero')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'hero' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        Hero Section
                    </button>
                    <button onClick={() => setActiveTab('stories')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'stories' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        School Stories (Approvals)
                    </button>
                    <button onClick={() => setActiveTab('testimonials')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'testimonials' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        Home Testimonials
                    </button>
                    <button onClick={() => setActiveTab('partners')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'partners' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        Trusted Partners
                    </button>
                    <button onClick={() => setActiveTab('partners2')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'partners2' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        Trusted Partners V2
                    </button>
                    <button onClick={() => setActiveTab('blog')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'blog' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        Blog Management
                    </button>
                    <button onClick={() => setActiveTab('faq')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'faq' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        FAQs
                    </button>
                    <button onClick={() => setActiveTab('about')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'about' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        About Us
                    </button>

                    {/* --- GROUP 3: SYSTEM SETTINGS --- */}
                    <p className="px-4 py-2 text-[10px] font-bold text-slate-500 uppercase tracking-widest mt-4">System</p>
                    
                    <button onClick={() => setActiveTab('formConfig')} className={`w-full text-left px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === 'formConfig' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:bg-slate-800'}`}>
                        Form Settings (Dropdowns)
                    </button>
                </nav>

                <div className="p-4 mt-auto border-t border-slate-800 sticky bottom-0 bg-slate-900">
                    <button onClick={handleLogout} className="w-full flex items-center gap-2 px-4 py-3 text-red-400 font-bold text-sm hover:text-white transition-colors">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg>
                        Logout
                    </button>
                </div>
            </aside>

            {/* MAIN CONTENT AREA */}
            <main className="flex-1 p-6 md:p-10 overflow-y-auto h-screen">
                <header className="mb-8 flex justify-between items-center">
                    <h2 className="text-2xl font-black text-slate-800 uppercase tracking-tight">
                        {activeTab === 'inquiries' && 'School Applications'}
                        {activeTab === 'candidates' && 'Candidates & Applications'}
                        {activeTab === 'hero' && 'Hero Management'}
                        {activeTab === 'partners' && 'Partners Management'}
                        {activeTab === 'partners2' && 'Partners Management (V2)'}
                        {activeTab === 'testimonials' && 'Home Testimonials'}
                        {activeTab === 'stories' && 'School Stories & Feedback'}
                        {activeTab === 'faq' && 'FAQ Management'}
                        {activeTab === 'about' && 'About Us Management'}
                        {activeTab === 'blog' && 'Blog Management'}
                        {activeTab === 'formConfig' && 'Form Configuration'}
                    </h2>
                    <div className="text-xs font-bold text-slate-400 bg-white px-4 py-2 rounded-full shadow-sm">
                        Admin Access
                    </div>
                </header>

                {/* Dynamic Content Render */}
                {renderContent()}
            </main>
        </div>
    );
};

export default AdminDashboard;